import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { formatDateLong, isEmpty, isEmptyArray } from '../../common/util.services';
import { getSyncReport, syncReportData, deleteSyncStatus } from '../amazon.services';
import dayjs from 'dayjs';
import FileUpload from './report-file.component';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/system';
import HMobiledataIcon from '@mui/icons-material/HMobiledata';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import AmazonSyncHistory from './sync-history.component';

const AmazonSyncReport = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const navigate = useNavigate();
  const [syncData, setSyncData] = useState(rows);
  const [fileUpload, setFileUpload] = useState(false);
  const [reportType, setReportType] = useState();
  const [openHistory, setOpenHistory] = useState(false);
  const [attribute, setAttribute] = useState('');
  const columns: GridColDef[] = [
    { field: 'attribute', headerName: 'Report', filterable: false, sortable: false, editable: false, width: 130 },
    { field: 'detail', headerName: 'Detail', filterable: false, sortable: false, editable: false, width: 450  },
    { field: 'startDate', headerName: 'Start Date', filterable: false, sortable: false, editable: false, width: 180,
      valueFormatter: (startDate: any) => isEmpty(startDate) ? 'NA' : formatDateLong(startDate)
    },
    { field: 'endDate', headerName: 'End Date', filterable: false, sortable: false, editable: false, width: 180,
      valueFormatter: (endDate: any) => isEmpty(endDate) ? 'NA' : formatDateLong(endDate)
    },
    { field: 'duration', headerName: 'Duration (Sec)', filterable: false, sortable: false, editable: false, width: 120,
      valueGetter: (value, row) => { return isEmpty(row.endDate) && isEmpty(row.startDate) ? 'NA' :
                                     dayjs(isEmpty(row.endDate) ? dayjs() : row.endDate).diff(dayjs(row.startDate), 'seconds')}
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 100  },
    { field: 'history', headerName: 'History', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                                <HMobiledataIcon fontSize='small' color="primary"/></Stack>),
    }
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getSyncReport(appContext,
        (response: any) => {
          setSyncData(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const syncReport = (value: any) => {
    setReportType(value.attribute);
    setFileUpload(true);
  }

  const closeFileUpload = () => {
    setFileUpload(false);
  }
  
  function isValidFileName (file: any) {
    if(isEmpty(file) || isEmpty(file.name)) {
      appContext.setDialogMessage('File is empty.');
      return false;
    } else {
      if(('SKU Return' === reportType && !file.name.includes('return-sku-')) ||
         ('SKU Ad Spend' === reportType && !file.name.includes('ad-spend-sku-')) ||
         ('Hourly Ad Spend' === reportType && !file.name.includes('ad-spend-hourly-'))) {
          appContext.setDialogMessage('Incorrect file name.');
          return false;
         }
    }
    return true;
  }

  const uploadFile = async (file: any) => {
    setFileUpload(false);
    if(isValidFileName(file)) {
      setFileUpload(false);
      const formData = new FormData();
      formData.append('file', file);
      setLoading(true);
      syncReportData(formData, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
      });
    }
  }

  const deleteSync = (value: any) => {
    deleteSyncStatus(value.rowId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        navigate(0);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const handleCellClick = (value: any) => {
    const field = value.field;
    if('history' === field) {
      setAttribute(value.row.attribute);
      setOpenHistory(true);
    }
  }

  const closeHistory = () => {
    setOpenHistory(false);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={syncData} columns={columns} loading={loading} hideFooter={true}
        showAction={true} showAddBtn={false} showDeleteAction={true} showEditAction={false} showApproveAction={false}
        showSyncAction={true} handleSyncAction={syncReport} handleDeleteAction={deleteSync}
        getRowId={(row: any) => row.attribute} maxHeight={500} cellClick={handleCellClick}/>
      <IDialogComponent onClose={closeFileUpload} open={fileUpload} title={'Select File'}
        dialogBody={<FileUpload uploadFile={uploadFile}/>} />
      <IDialogComponent onClose={closeHistory} open={openHistory} title={'Sync History'}
        dialogBody={<AmazonSyncHistory attribute={attribute} close={closeHistory}/>} />
    </>
  }

  return <TitlePanel title='Sync Report' panelBody={getMainPanel()} />
}

export default AmazonSyncReport;